<p-dialog
    [(visible)]="episodeSelectDialogVisible"
    [modal]="true"
    appendTo="body"
    header="Please select an episode"
    [resizable] ="false"
    [closable]="false"
    [style]="{ 'max-width': '550px', width: '100%' }"
    styleClass="center-header m-dialog-header-text">
    <div class="inputs-group pt-2">
        <div class="inputs-group-row">
            <episode-select
                [disabled]="episodeSelectLocked"
                [episodeId]="episodeId"
                [episode]="episode"
                [selectionModes]="selectionModes"
                [(ngModel)]="episodeSelectOption"
                [offlineInvalidModes]="offlineInvalidModes"
                [originallySelectedOption]="episodeSelectOption"
                [ngModelOptions]="{ standalone: true }"
                [restoreDuplicateCheakState]="restoreDuplicateCheakState"
                [restoreSelectControlState]="restoreSelectControlState"
                [restoreSelectDialog]="restoreSelectDialog"
                [isWalkInDraft]="isWalkInDraft"
                [isPrescription]="isPrescription"
                [patientId]="patientId"
                [createFrom]="createFrom"
                [surveyInstance]="surveyInstance"
                [assignedClinicianId]="assignedClinicianId"
                [assignedClinicianVisible]="false"
                (viewEpisode)="viewEpisode.emit($event)"
                (ngModelChange)="onEpisodeChange($event)">
            </episode-select>
        </div>
    </div>

    <div class="flex justify-content-end" >
        <button pButton type="button" label="Cancel" class="p-button-secondary" (click)="onCancel.emit()">
            <i class="material-icons">clear</i>
        </button>

        <button
            [disabled]="episodeRequired && !episode "
            pButton
            type="button"
            [label]="episode ? 'Ok': 'Skip' "
            class="m-button-primary ml-2"
            (click)="onSkip.emit(episode)">
            <i class="material-icons">check</i>
        </button>
    </div>
</p-dialog>

